module.exports = __webpack_public_path__ + "img/united-arab-emirates.0fd33949.png";